import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AssignPatientsToTimelineModalComponent } from 'app/ui/assign-patients-to-timeline-modal/assign-patients-to-timeline-modal.component';
import { Observable, of, switchMap } from 'rxjs';
import { PatientApiService } from '@domain/patient/service/patient-api.service';
import { PageDTO } from '@data/common/pagination/PageDTO';
import { PatientDTO } from '@data/common/PatientDTO';
import { PatientPageCriteriaDTO } from '@data/common/pagination/PatientPageCriteriaDTO';
import { PatientMigrationStatus } from '@domain/patient/data/PatientMigrationStatus';
import { AccountDTO } from '@data/auth/AccountDTO';
import { PsychologistApiService } from '@domain/psychologist/service/psychologist-api.service';
import { AssignPatientToPsychologistsTimelineDTO } from '@domain/psychologist/data/AssignPatientToPsychologistsTimelineDTO';

@Injectable({ providedIn: 'root' })
export class AssignPatientToTimelineFacadeService {

  constructor(private readonly bsModalService: BsModalService, private patientApiService: PatientApiService, private psychologistsApiService: PsychologistApiService) {
  }

  public showAssignPatientToTimelineModal(account: AccountDTO) {
    const criteria = new PatientPageCriteriaDTO();
    criteria.pageSize = 100;
    criteria.migrationStatus = PatientMigrationStatus.NOT_MIGRATED;
    criteria.assignedPsychologistId = account.id;

    return this.patientApiService.loadPatientsPage(criteria).pipe(
      switchMap((patientPage: PageDTO<PatientDTO>) => this.bsModalService.show(AssignPatientsToTimelineModalComponent, {
        ignoreBackdropClick: true,
        class: 'modal-dialog-centered modal-xl',
        initialState: {
          patients: patientPage.content
        }
      }).content.close$.pipe(switchMap((request) => this.assignPatients(request))))
    );
  }

  public skipPatientsAssignments(): Observable<void> {
    return this.psychologistsApiService.skipPatientAssignment()
  }

  public assignPatients(request: AssignPatientToPsychologistsTimelineDTO[]): Observable<void> {
    return this.psychologistsApiService.assignPatientsToPsychologistsTimeline(request)
  }
}
